module.exports = __webpack_public_path__ + "img/ubicacion.beb93fd9.png";